import React, { useEffect, useState } from "react";
import TabSelection from "../../../../components/commons/TabSelection";
import { onBoardingDetailMenu } from "../data";
import PersonalInfo from "./PersonalInfo";
import { ArrowBack } from "@material-ui/icons";
import CompanyInformation from "./CompanyInformation";
import { useLocation, useNavigate, useParams } from "react-router";
import { connect } from "react-redux";
import mobioApi from "../../../../services";
import MargeRendering from "./MargeRendering";
import ThunksOnboardingListing from "../../../../redux/actions/thunks/onboarding-listing";
import UserProfileModal from "../modals/UserProfileModal";

const Index = ({ token, CheckDisplayName }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const { status, page } = location.state || {};

  const [menuType, setMenuType] = useState("personal_information");
  const [userDetail, setUserDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [userProfileModal, setUserProfileModal] = useState(false);

  const getOnboardingDriverDetail = async (userId) => {
    try {
      if (!userId) return;
      setLoading(true);

      const api = mobioApi(token);
      const response = await api.getOnboardingSingleDetail(userId);

      if (response?.data?.data) {
        setUserDetail(response.data.data);
      } else {
        setUserDetail(null);
      }
    } catch (error) {
      console.error("Error fetching onboarding detail:", error);
      setUserDetail(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getOnboardingDriverDetail(id);
  }, [id]);
  return (
    <div>
      <div className="flex align-item-center">
        <ArrowBack
          className="cursor-pointer"
          onClick={() => {
            navigate("/dashboard/onboardings/v2", {
              state: {
                status,
                page,
              },
            });
          }}
        />
        <img
          onClick={() => {
            setUserProfileModal(true);
          }}
          src={
            userDetail?.user?.imageUrl ||
            "https://avatar.iran.liara.run/public/29"
          }
          alt="icon"
          className="avatar-md ml-10 cursor-pointer"
        />
        <p className="ml-10 font-16 font-600">
          {" "}
          {userDetail?.user?.displayaName || userDetail?.user?.fullName}
        </p>
      </div>
      {/* tab menu start  */}
      <div className="">
        <div className="flex justify-content-between align-item-center">
          <div>
            <TabSelection
              menu={onBoardingDetailMenu}
              defaultSelected={onBoardingDetailMenu[0].title}
              onMenuChange={(tab) => {
                setMenuType(tab?.value);
              }}
            />
          </div>
          {/* <div className="flex gap-12 align-item-end">
            <div className="ml-12">
              <MOButtonV2
                text="APPROVAL"
                textColor="#ffffff"
                radius={4}
                backgroundColor="#29AEE6"
                // onClick={() => {
                //   setLeadTimeModalOpen(true);
                // }}
                height={30}
                fontSize={12}
                padding={"8px 32px"}
              />
            </div>
            <div className="ml-12">
              <MOButtonV2
                text="REJECT"
                textColor="#ffffff"
                radius={4}
                backgroundColor="#ff3b30"
                // onClick={() => {
                //   setLeadTimeModalOpen(true);
                // }}
                height={30}
                fontSize={12}
                padding={"8px 32px"}
              />
            </div>
          </div> */}
        </div>
      </div>
      {/* tab menu end  bg-white border-radius-8  */}
      <div className="mt-28">
        {loading ? (
          <>
            <div className="text-align-center p-20 font-17">Loading...</div>
          </>
        ) : (
          <>
            {menuType === "personal_information" && (
              <PersonalInfo
                onboardingData={userDetail}
                CheckDisplayName={CheckDisplayName}
                token={token}
              />
            )}
            {menuType === "company_information" && (
              <CompanyInformation onboardingData={userDetail} token={token} />
            )}
            {menuType === "vehicle_details_other" && (
              <MargeRendering onboardingData={userDetail} token={token} />
            )}
            {/* {menuType === "other" && (
              <OtherDocumentsInfo onboardingData={userDetail} />
            )} */}
          </>
        )}
      </div>
      {userProfileModal && (
        <UserProfileModal
          modalOpen={userProfileModal}
          setModalOpen={setUserProfileModal}
          userImageLink={userDetail?.user?.imageUrl}
        />
      )}
    </div>
  );
};

const mapState = (state) => ({
  token: state.userInfo.token,
});

const mapDispatch = {
  CheckDisplayName: ThunksOnboardingListing.CheckDisplayName,
};

export default connect(mapState, mapDispatch)(Index);
